// Utils
import { createNamespace } from '../utils';
import { inherit } from '../utils/functional';
// Components
import Cell from '../cell';
import Switch from '../switch';
import { switchProps } from '../switch/shared';
const [createComponent, bem] = createNamespace('switch-cell');
function SwitchCell(h, props, slots, ctx) {
    if (process.env.NODE_ENV === 'development') {
        console.warn('[Vant] "SwitchCell" component is deprecated, see: https://youzan.github.io/vant/#/zh-CN/switch-cell.');
    }
    return (<Cell center size={props.cellSize} title={props.title} border={props.border} class={bem([props.cellSize])} {...inherit(ctx)}>
      <Switch {...{ props, on: ctx.listeners }}/>
    </Cell>);
}
SwitchCell.props = {
    ...switchProps,
    title: String,
    cellSize: String,
    border: {
        type: Boolean,
        default: true,
    },
    size: {
        type: String,
        default: '24px',
    },
};
export default createComponent(SwitchCell);
